import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../store/stores.js";
/**
 * Inline notification outlet. Renders every notification tagged with the
 * given channel as an Antd `<Alert>`. Place one in any layout slot where
 * channel-targeted messages should surface (above a form, between sections,
 * in a sidebar) — the same store entry can drive multiple outlets if
 * needed.
 */ const Notifications = observer(({ channel, className })=>{
    const { notificationStore } = useStores();
    const notifications = notificationStore.getByChannel(channel);
    if (notifications.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: notifications.map(({ id, type, message, title, closable })=>/*#__PURE__*/ _jsx(Alert, {
                type: type,
                showIcon: true,
                closable: closable ?? true,
                message: title ?? message,
                description: title ? message : undefined,
                onClose: ()=>notificationStore.remove(id),
                className: "rc-notification"
            }, id))
    });
});
export { Notifications };
